// Dashboard.tsx
import React, { useEffect, useState } from 'react';
import { Box, Grid, Card, CardContent, Typography, Paper } from '@mui/material';
import { getPendingApprovals, getRecentListing, getSummary } from './Dashboard.service';
import { showErrorToast } from '../../common/util/util';
import CustomizedTables from '../../common/Table';
import { useCountryParam } from '../../common/util/useCountryParam';

interface Metrics {
  totalProperties?: number;
  activeListings?: number;
  totalUsers?: number;
  revenue?: number;
  pendingApprovals?: number;
  [k: string]: any;
}

const Dashboard: React.FC = () => {
  const country = useCountryParam();
  const [metrics, setMetrics] = useState<Metrics>({});

  // fetch metrics
  useEffect(() => {
    getSummary(country)
      .then((res: any) => setMetrics(res ?? {}))
      .catch((err) => showErrorToast(err));

    getPendingApprovals(country)
      .then((res: any) => {
        setMetrics((prev: Metrics) => ({ ...prev, pendingApprovals: res?.pendingApprovals ?? 0 }));
      })
      .catch((err) => showErrorToast(err));
  }, [country]);

  const ukColumns = [
    { key: 'name', label: "Name", minWidth: 150 },
    { key: 'location', label: "Location", minWidth: 150 },
    { key: 'status', label: "Status", minWidth: 150 },
    { key: 'rentOrPrice', label: "Price", minWidth: 150 },
  ];

  const indiaColumns = [
    { key: 'title', label: "Title", minWidth: 150 },
    { key: 'address', label: "Location", minWidth: 150 },
    { key: 'status', label: "Status", minWidth: 150 },
    { key: 'price', label: "Price", minWidth: 150 },
    { key: 'type', label: "Type", minWidth: 100 },
  ];

  const columns = country === 'india' ? indiaColumns : ukColumns;

  return (
    <Box paddingY={6}>
      <Typography variant="h5" mb={2} mt={2}>Admin Dashboard ({country.toUpperCase()})</Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <Card><CardContent><Typography variant="h6">Total Properties</Typography><Typography variant="h4">{metrics.totalProperties ?? 0}</Typography></CardContent></Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card><CardContent><Typography variant="h6">Active Listings</Typography><Typography variant="h4">{metrics.activeListings ?? 0}</Typography></CardContent></Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card><CardContent><Typography variant="h6">Total Users</Typography><Typography variant="h4">{metrics.totalUsers ?? 0}</Typography></CardContent></Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card><CardContent><Typography variant="h6">Revenue</Typography><Typography variant="h4">{metrics.revenue ?? 0}</Typography></CardContent></Card>
        </Grid>
      </Grid>

      <Box mt={4}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" mb={2}>Recent Listings</Typography>
          <CustomizedTables columns={columns} listService={() => getRecentListing(country)} isDashBoard />
        </Paper>
      </Box>
    </Box>
  );
};

export default Dashboard;
